import React, { Component } from 'react';
import PageTitle from "../../../Components/PageTitle";
import { TextBox, TextArea, SubmitBtn } from "../../../Components/InputElements";
import axios from 'axios';
import Swal from 'sweetalert2';
import withRouter from '../../../Utils/withRouter';
import { ConfigContext } from '../../../Context/ConfigContext'
import { currentDateAndTime, decodeData } from '../../../Constants/constants';
class RegularizationSettings extends Component {
    static contextType = ConfigContext;
    constructor(props) {
        super(props);
        this.state = {
            regularize_setting_id: 0,
            regularization_apply_days: '',
            days_for_rm_action: '',
            approval_level_notification: '1',
            parallel_approvals: '1',
            request_move_to_level2: '1',
            level2_approval_depends_level1: '1',
            rm_multi_action: '1',
            rejection_level_notification: '1',
            level1_rm_notification: ['3'],
            level2_rm_notification: ['3'],
            employee_approval_notification: ['3'],
            employee_rejection_notification: ['3'],
            rm_approval_levels: '1',
            rm_apply_regularization: '1',
            regularize_after_payroll: '1',
            postLoading: false,
            decodedData: [],
        };
    }
    componentDidMount() {
        this.setState({ loadingList: true }, (prevState) => {
            this.GetRegularizationSettingsInfo();
        })
    }
    componentDidUpdate(prevProps, prevState) {
            if (prevState.permissions !== this.context.permissions) {
              // console.log("Permissions Updated:", this.context.permissions);
                const { permissions } = this.context;
                if (permissions.length > 0) {
                  const queryParams = new URLSearchParams(window.location.search);
                  const encodedData = queryParams.get("abs");
                  const decodedData = encodedData ? decodeData(encodedData, permissions) : [0];
                  if (JSON.stringify(prevState.decodedData) !== JSON.stringify(decodedData)) {
                    this.setState({ decodedData });
                  }
                } else {
                  console.warn("Permissions not yet available. Retrying...");
                }
            }
    }
    handleInputChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value,
        });
    };

    GetRegularizationSettingsInfo = () => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Attendance/GetRegularizationSettingInfo`, { headers }).then((response) => {
            var data = response.data.data;
            if (response.data.success === true && data.length !== 0) {
                this.setState({
                    regularize_setting_id: data[0].regularize_setting_id,
                    regularization_apply_days: data[0].regularization_apply_days,
                    days_for_rm_action: data[0].days_for_rm_action,
                    approval_level_notification: data[0].approval_level_notification,
                    parallel_approvals: data[0].parallel_approvals,
                    request_move_to_level2: data[0]?.request_move_to_level2,
                    level2_approval_depends_level1: data[0]?.level2_approval_depends_level1,
                    rm_multi_action: data[0].rm_multi_action,
                    rejection_level_notification: data[0].rejection_level_notification,
                    level1_rm_notification: JSON.parse(data[0].level1_rm_notification),
                    level2_rm_notification: JSON.parse(data[0].level2_rm_notification),
                    employee_approval_notification: JSON.parse(data[0].employee_approval_notification),
                    employee_rejection_notification: JSON.parse(data[0].employee_rejection_notification),
                    rm_approval_levels: data[0].rm_approval_levels,
                    rm_apply_regularization: data[0].rm_apply_regularization,
                    regularize_after_payroll: data[0]?.regularize_after_payroll,
                    loadingList: false,
                });
            } else {
                this.setState({ loadingList: false });
            }
        });
    }

    handleSubmit = (e) => {
        e.preventDefault();
        this.setState({ postLoading: true });
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        var formData = {
            regularization_apply_days: this.state?.regularization_apply_days,
            days_for_rm_action: this.state?.days_for_rm_action,
            approval_level_notification: this.state?.approval_level_notification,
            parallel_approvals: this.state?.parallel_approvals,
            request_move_to_level2: this.state?.request_move_to_level2,
            level2_approval_depends_level1: this.state?.level2_approval_depends_level1,
            rm_multi_action: this.state?.rm_multi_action,
            rejection_level_notification: this.state?.rejection_level_notification,
            level1_rm_notification: this.state?.level1_rm_notification,
            level2_rm_notification: this.state?.level2_rm_notification,
            employee_approval_notification: this.state?.employee_approval_notification,
            employee_rejection_notification: this.state?.employee_rejection_notification,
            rm_approval_levels: this.state?.rm_approval_levels,
            rm_apply_regularization: this.state?.rm_apply_regularization,
            regularize_after_payroll: this.state?.regularize_after_payroll,
            date: currentDateAndTime(),
        }
        if (this.state.regularize_setting_id != 0) {
            formData.regularize_setting_id = this.state.regularize_setting_id;
        }

        axios.post(`${apiURL}Attendance/UpdateRegularizationSetting`, formData, { headers }).then((response) => {
            const { success } = response.data;
            if (success === true) {
                

                Swal.fire({
                    title: `<strong>${success ? 'Success' : 'Failed'}</strong>`,
                    text: response.data.message,
                    icon: success ? 'success' : 'error',
                    showConfirmButton: true,  // Show OK button
                }).then((result) => {
                    if (result.isConfirmed) {
                        // Optional: You can perform any action here after OK is clicked
                        this.setState({ loadingList: true, postLoading: false }, (prevState) => { });
                        this.GetRegularizationSettingsInfo();  // Call your function after the alert is closed
                    }
                });
            } else {
                Swal.fire({
                    title: `<strong>${success ? 'Success' : 'Failed'}</strong>`,
                    text: response.data.message,
                    icon: success ? 'success' : 'error',
                    showConfirmButton: true,  // Show OK button
                }).then((result) => {
                    if (result.isConfirmed) {
                        // Optional: Action after the OK button is clicked
                        this.setState({ loadingList: true, postLoading: false }, (prevState) => { });
                    }
                });

            }

        })
    };


    handleRadioChange = (name, value) => {

        this.setState((prevState) => ({
            [name]: value,
            errors: {
                ...prevState.errors,
                [name]: '',
            },
        }));

    };

    handleCheckBoxChange = (name, value) => {
        const isChecked = this.state[name].find(option => option === value);
        if (isChecked) {
            this.setState(prevState => ({
                [name]: prevState[name].filter(option => option !== value),
                errors: {
                    ...prevState.errors,
                    [name]: '',
                },
            }));
        } else {
            this.setState(prevState => ({
                [name]: [...prevState[name], value],
                errors: {
                    ...prevState.errors,
                    [name]: '',
                },
            }));
        }
    };


    render() {
        return (
            <div className="main-content">
                <div className="page-content">
                    <div className="container-fluid">
                        <br />
                        <PageTitle title={`Regularization Settings`} primary={`Home`} />
                        <div className="row">
                            <div className="col-md-12">
                                <div className="card">
                                    <div className="card-header align-items-center d-flex">
                                        <h4 className="card-title mb-0 flex-grow-1">Regularization Settings</h4>
                                    </div>
                                    <div className="card-body">
                                        <div className="row gy-4">
                                            <div className="col-md-12">
                                                <form onSubmit={this.handleSubmit} className="row settings-form">
                                                    {/* Regularization Settings */}

                                                    <div className="col-md-6 mt-3 settings-section">
                                                        <div>
                                                            <label style={{opacity:"0.5"}}>Can Employee apply for the regularization once the monthly salary is processed</label>
                                                        </div>
                                                        <div className="form-check form-check-inline mt-2">
                                                            <input
                                                                type="radio"
                                                                id="regularize_after_payroll_yes"
                                                                name="regularize_after_payroll"
                                                                value="yes"
                                                                checked={this.state.regularize_after_payroll === '1'}
                                                                onChange={() => this.handleRadioChange('regularize_after_payroll', '1')}
                                                                className="form-check-input"
                                                                disabled
                                                            />
                                                            <label htmlFor="regularize_after_payroll_yes" className="form-check-label">Yes</label>
                                                        </div>
                                                        <div className="form-check form-check-inline">
                                                            <input
                                                                type="radio"
                                                                id="regularize_after_payroll_no"
                                                                name="regularize_after_payroll"
                                                                value="no"
                                                                checked={this.state.regularize_after_payroll === '0'}
                                                                onChange={() => this.handleRadioChange('regularize_after_payroll', '0')}
                                                                className="form-check-input"
                                                                disabled
                                                            />
                                                            <label htmlFor="regularize_after_payroll_no" className="form-check-label">No</label>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 mt-3 mb-3 settings-section">
                                                        <label>Within how many days should the regularization be applied</label>
                                                        <input
                                                            type='number'
                                                            className='form-control'
                                                            name='regularization_apply_days'
                                                            value={this.state.regularization_apply_days}
                                                            placeholder='Enter regularization days limit'
                                                            onChange={this.handleInputChange}
                                                        />
                                                    </div>

                                                    {/* RM Approval Duration Setting */}
                                                    <div className="col-md-6 mt-3 settings-section">
                                                        <label>Time duration for RM to Approve/Reject <small className="text-muted">(No. of Days)</small>:</label>
                                                        <input
                                                            type='number'
                                                            className='form-control'
                                                            name='days_for_rm_action'
                                                            value={this.state.days_for_rm_action}
                                                            placeholder='Enter duration in days'
                                                            onChange={this.handleInputChange}
                                                        />
                                                    </div>

                                                    {/* Move to RM's RM Setting */}

                                                    <div className="col-md-6 mt-3 settings-section">
                                                        <div>
                                                            <label style={{opacity:"0.5"}}>Can RM Apply for Regularization request on behalf of Employee</label>
                                                        </div>
                                                        <div className="form-check form-check-inline mt-2">
                                                            <input
                                                                type="radio"
                                                                id="rm_apply_regularization_yes"
                                                                name="rm_apply_regularization"
                                                                value="yes"
                                                                checked={this.state.rm_apply_regularization === '1'}
                                                                onChange={() => this.handleRadioChange('rm_apply_regularization', '1')}
                                                                className="form-check-input"
                                                                disabled
                                                            />
                                                            <label htmlFor="rm_apply_regularization_yes" className="form-check-label">Yes</label>
                                                        </div>
                                                        <div className="form-check form-check-inline">
                                                            <input
                                                                type="radio"
                                                                id="rm_apply_regularization_no"
                                                                name="rm_apply_regularization"
                                                                value="no"
                                                                checked={this.state.rm_apply_regularization === '0'}
                                                                onChange={() => this.handleRadioChange('rm_apply_regularization', '0')}
                                                                className="form-check-input"
                                                                disabled
                                                            />
                                                            <label htmlFor="rm_apply_regularization_no" className="form-check-label">No</label>
                                                        </div>
                                                    </div>
                                                    {/* Admin Approval Levels Setting */}
                                                    <div className="col-md-6 mt-3 settings-section" style={this.state.rm_approval_levels.includes("2") ? { backgroundColor: "#fafafa", borderTopLeftRadius: "8px", borderBottomLeftRadius: "8px", padding: '4px' } : { backgroundColor: "white" }}>
                                                        <div>
                                                            <label>RM Approval Levels</label>
                                                        </div>
                                                        <div className="form-check">
                                                            <input
                                                                type="checkbox"
                                                                id="rm_approval_levels1"
                                                                name="rm_approval_levels1"
                                                                value="1"
                                                                checked={this.state.rm_approval_levels.includes('1') || this.state.rm_approval_levels.includes('2')}
                                                                onChange={() => this.handleRadioChange('rm_approval_levels', '1')}
                                                                className="form-check-input"

                                                            />
                                                            <label htmlFor="rm_approval_levels1" className="form-check-label">Level1</label>
                                                        </div>
                                                        <div className="form-check">
                                                            <input
                                                                type="checkbox"
                                                                id="rm_approval_levels2"
                                                                name="rm_approval_levels2"
                                                                value="2"
                                                                checked={this.state.rm_approval_levels.includes('2')}
                                                                onChange={(e) => this.handleRadioChange('rm_approval_levels', `${e.target.checked ? 2 : 1}`)}
                                                                className="form-check-input"
                                                                disabled
                                                            />
                                                            <label htmlFor="rm_approval_levels2" className="form-check-label">Level2</label>
                                                        </div>

                                                        {this.state.rm_approval_levels.includes("2") &&
                                                            <div className='mt-3' style={{ marginLeft: '30px' }}>
                                                                <div>
                                                                    <label style={{opacity:"0.5"}}>Do you want parallel approvals <br />
                                                                        <small className='text-muted'>({this.state.parallel_approvals == '1' ? 'Will allow Level1 OR Level2 to act regardless another level action' : 'Level2 will be able to act only once Level1 has Approved'})</small>
                                                                    </label>
                                                                </div>
                                                                <div className="form-check form-check-inline mt-2">
                                                                    <input
                                                                        type="radio"
                                                                        id="parallel_approvals_yes"
                                                                        name="parallel_approvals"
                                                                        value="1"
                                                                        checked={this.state.parallel_approvals === '1'}
                                                                        onChange={() => this.handleRadioChange('parallel_approvals', '1')}
                                                                        className="form-check-input"
                                                                        disabled
                                                                    />
                                                                    <label htmlFor="parallel_approvals_yes" className="form-check-label">Yes</label>
                                                                </div>
                                                                <div className="form-check form-check-inline">
                                                                    <input
                                                                        type="radio"
                                                                        id="parallel_approvals_no"
                                                                        name="parallel_approvals"
                                                                        value="0"
                                                                        checked={this.state.parallel_approvals === '0'}
                                                                        onChange={() => this.handleRadioChange('parallel_approvals', '0')}
                                                                        className="form-check-input"
                                                                        disabled
                                                                    />
                                                                    <label htmlFor="parallel_approvals_no" className="form-check-label">No</label>
                                                                </div>
                                                            </div>}

                                                    </div>
                                                    {this.state.rm_approval_levels.includes("2") &&
                                                        <div className='col-md-6 settings-section mt-3' style={this.state.rm_approval_levels.includes("2") ? { backgroundColor: "#fafafa", borderTopRightRadius: "8px", borderBottomRightRadius: "8px", padding: '4px' } : { backgroundColor: "white" }}>
                                                            <div>
                                                                <label style={{opacity:"0.5"}}>Should request move to the Level2 RM if Level1 RM does not take action within set number of days
                                                                </label>
                                                            </div>
                                                            <div className="form-check form-check-inline mt-2">
                                                                <input
                                                                    type="radio"
                                                                    id="request_move_to_level2_yes"
                                                                    name="request_move_to_level2"
                                                                    value="1"
                                                                    checked={this.state.request_move_to_level2 === '1'}
                                                                    onChange={() => this.handleRadioChange('request_move_to_level2', '1')}
                                                                    className="form-check-input"
                                                                    disabled
                                                                />
                                                                <label htmlFor="request_move_to_level2_yes" className="form-check-label">Yes</label>
                                                            </div>
                                                            <div className="form-check form-check-inline">
                                                                <input
                                                                    type="radio"
                                                                    id="request_move_to_level2_no"
                                                                    name="request_move_to_level2"
                                                                    value="0"
                                                                    checked={this.state.request_move_to_level2 === '0'}
                                                                    onChange={() => this.handleRadioChange('request_move_to_level2', '0')}
                                                                    className="form-check-input"
                                                                    disabled
                                                                />
                                                                <label htmlFor="request_move_to_level2_no" className="form-check-label">No</label>
                                                            </div>

                                                            <div className='mt-4'>
                                                                <label style={{opacity:"0.5"}}>If Level2 RM approve the request then should Level1 RM require to approve</label>
                                                            </div>
                                                            <div className="form-check form-check-inline mt-2">
                                                                <input
                                                                    type="radio"
                                                                    id="level2_approval_depends_level1_yes"
                                                                    name="level2_approval_depends_level1"
                                                                    value="1"
                                                                    checked={this.state.level2_approval_depends_level1 === '1'}
                                                                    onChange={() => this.handleRadioChange('level2_approval_depends_level1', '1')}
                                                                    className="form-check-input"
                                                                    disabled
                                                                />
                                                                <label htmlFor="level2_approval_depends_level1_yes" className="form-check-label">Yes</label>
                                                            </div>
                                                            <div className="form-check form-check-inline">
                                                                <input
                                                                    type="radio"
                                                                    id="level2_approval_depends_level1_no"
                                                                    name="level2_approval_depends_level1"
                                                                    value="0"
                                                                    checked={this.state.level2_approval_depends_level1 === '0'}
                                                                    onChange={() => this.handleRadioChange('level2_approval_depends_level1', '0')}
                                                                    className="form-check-input"
                                                                    disabled
                                                                />
                                                                <label htmlFor="level2_approval_depends_level1_no" className="form-check-label">No</label>
                                                            </div>
                                                        </div>}
                                                    {/* Move to RM's RM Setting */}
                                                    <div className="col-md-6 mt-3 settings-section mt-5">
                                                        <div>
                                                            <label>Can RM Approve/Reject Multiple requests in one go</label>
                                                        </div>
                                                        <div className="form-check form-check-inline mt-2">
                                                            <input
                                                                type="radio"
                                                                id="rm_multi_action_yes"
                                                                name="rm_multi_action"
                                                                value="yes"
                                                                checked={this.state.rm_multi_action === '1'}
                                                                onChange={() => this.handleRadioChange('rm_multi_action', '1')}
                                                                className="form-check-input"
                                                            />
                                                            <label htmlFor="rm_multi_action_yes" className="form-check-label">Yes</label>
                                                        </div>
                                                        <div className="form-check form-check-inline">
                                                            <input
                                                                type="radio"
                                                                id="rm_multi_action_no"
                                                                name="rm_multi_action"
                                                                value="no"
                                                                checked={this.state.rm_multi_action === '0'}
                                                                onChange={() => this.handleRadioChange('rm_multi_action', '0')}
                                                                className="form-check-input"
                                                            />
                                                            <label htmlFor="rm_multi_action_no" className="form-check-label">No</label>
                                                        </div>
                                                    </div>


                                                    <div className="card-header align-items-center d-flex mt-5">
                                                        <h4 className="card-title mb-0 flex-grow-1">Regularization Notification Settings</h4>
                                                    </div>

                                                    <div className="col-md-6 mt-3 settings-section">
                                                        <div>
                                                            <label>Should the Level1 RM receive a notification for every request on</label>
                                                        </div>
                                                        <div className="form-check">
                                                            <input
                                                                type="checkbox"
                                                                id="level1_rm_notification1"
                                                                name="level1_rm_notification1"
                                                                value="1"
                                                                checked={this.state.level1_rm_notification.includes('1')}
                                                                onChange={() => this.handleCheckBoxChange('level1_rm_notification', '1')}
                                                                className="form-check-input"
                                                            />
                                                            <label htmlFor="level1_rm_notification1" className="form-check-label">a) Mobile</label>
                                                        </div>
                                                        {/* <div className="form-check">
                                                            <input
                                                                type="checkbox"
                                                                id="level1_rm_notification2"
                                                                name="level1_rm_notification2"
                                                                value="2"
                                                                checked={this.state.level1_rm_notification.includes('2')}
                                                                onChange={(e) => this.handleCheckBoxChange('level1_rm_notification', '2')}
                                                                className="form-check-input"
                                                            />
                                                            <label htmlFor="level1_rm_notification2" className="form-check-label">b) Web</label>
                                                        </div> */}
                                                        <div className="form-check">
                                                            <input
                                                                type="checkbox"
                                                                id="level1_rm_notification3"
                                                                name="level1_rm_notification3"
                                                                value="2"
                                                                checked={this.state.level1_rm_notification.includes('3')}
                                                                onChange={(e) => this.handleCheckBoxChange('level1_rm_notification', '3')}
                                                                className="form-check-input"
                                                            />
                                                            <label htmlFor="level1_rm_notification3" className="form-check-label">b) Email</label>
                                                        </div>
                                                    </div>

                                                    <div className="col-md-6 mt-3 settings-section">
                                                        <div>
                                                            <label>Should the Level2 RM receive a notification for every request on</label>
                                                        </div>
                                                        <div className="form-check">
                                                            <input
                                                                type="checkbox"
                                                                id="level2_rm_notification1"
                                                                name="level2_rm_notification1"
                                                                value="1"
                                                                checked={this.state.level2_rm_notification.includes('1')}
                                                                onChange={() => this.handleCheckBoxChange('level2_rm_notification', '1')}
                                                                className="form-check-input"
                                                            />
                                                            <label htmlFor="level2_rm_notification1" className="form-check-label">a) Mobile</label>
                                                        </div>
                                                        {/* <div className="form-check">
                                                            <input
                                                                type="checkbox"
                                                                id="level2_rm_notification2"
                                                                name="level2_rm_notification2"
                                                                value="2"
                                                                checked={this.state.level2_rm_notification.includes('2')}
                                                                onChange={(e) => this.handleCheckBoxChange('level2_rm_notification', '2')}
                                                                className="form-check-input"
                                                            />
                                                            <label htmlFor="level2_rm_notification2" className="form-check-label">b) Web</label>
                                                        </div> */}
                                                        <div className="form-check">
                                                            <input
                                                                type="checkbox"
                                                                id="level2_rm_notification3"
                                                                name="level2_rm_notification3"
                                                                value="2"
                                                                checked={this.state.level2_rm_notification.includes('3')}
                                                                onChange={(e) => this.handleCheckBoxChange('level2_rm_notification', '3')}
                                                                className="form-check-input"
                                                            />
                                                            <label htmlFor="level2_rm_notification3" className="form-check-label">b) Email</label>
                                                        </div>
                                                    </div>

                                                    <div className="col-md-6 mt-5 settings-section">
                                                        <div>
                                                            <label>Should the employee receive a notification for every approval on</label>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-md-4">
                                                                <div className="form-check">
                                                                    <input
                                                                        type="checkbox"
                                                                        id="employee_approval_notification1"
                                                                        name="employee_approval_notification1"
                                                                        value="1"
                                                                        checked={this.state.employee_approval_notification.includes('1')}
                                                                        onChange={() => this.handleCheckBoxChange('employee_approval_notification', '1')}
                                                                        className="form-check-input"
                                                                    />
                                                                    <label htmlFor="employee_approval_notification1" className="form-check-label">a) Mobile</label>
                                                                </div>
                                                                {/* <div className="form-check">
                                                                    <input
                                                                        type="checkbox"
                                                                        id="employee_approval_notification2"
                                                                        name="employee_approval_notification2"
                                                                        value="2"
                                                                        checked={this.state.employee_approval_notification.includes('2')}
                                                                        onChange={(e) => this.handleCheckBoxChange('employee_approval_notification', '2')}
                                                                        className="form-check-input"
                                                                    />
                                                                    <label htmlFor="employee_approval_notification2" className="form-check-label">b) Web</label>
                                                                </div> */}
                                                                <div className="form-check">
                                                                    <input
                                                                        type="checkbox"
                                                                        id="employee_approval_notification3"
                                                                        name="employee_approval_notification3"
                                                                        value="2"
                                                                        checked={this.state.employee_approval_notification.includes('3')}
                                                                        onChange={(e) => this.handleCheckBoxChange('employee_approval_notification', '3')}
                                                                        className="form-check-input"
                                                                    />
                                                                    <label htmlFor="employee_approval_notification3" className="form-check-label">b) Email</label>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <div className="form-check">
                                                                    <input
                                                                        type="checkbox"
                                                                        id="approval_level_notification1"
                                                                        name="approval_level_notification1"
                                                                        value="1"
                                                                        checked={this.state.approval_level_notification.includes('1') || this.state.approval_level_notification.includes('2')}
                                                                        onChange={() => this.handleRadioChange('approval_level_notification', '1')}
                                                                        className="form-check-input"
                                                                    />
                                                                    <label htmlFor="approval_level_notification1" className="form-check-label">Level1</label>
                                                                </div>
                                                                <div className="form-check">
                                                                    <input
                                                                        type="checkbox"
                                                                        id="approval_level_notification2"
                                                                        name="approval_level_notification2"
                                                                        value="2"
                                                                        checked={this.state.approval_level_notification.includes('2')}
                                                                        onChange={(e) => this.handleRadioChange('approval_level_notification', `${e.target.checked ? 2 : 1}`)}
                                                                        className="form-check-input"
                                                                    />
                                                                    <label htmlFor="approval_level_notification2" className="form-check-label">Level2</label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="col-md-6 mt-5 settings-section">
                                                        <div>
                                                            <label>Should the employee receive a notification for every rejection on</label>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-md-4">
                                                                <div className="form-check">
                                                                    <input
                                                                        type="checkbox"
                                                                        id="employee_rejection_notification1"
                                                                        name="employee_rejection_notification1"
                                                                        value="1"
                                                                        checked={this.state.employee_rejection_notification.includes('1')}
                                                                        onChange={() => this.handleCheckBoxChange('employee_rejection_notification', '1')}
                                                                        className="form-check-input"
                                                                    />
                                                                    <label htmlFor="employee_rejection_notification1" className="form-check-label">a) Mobile</label>
                                                                </div>
                                                                {/* <div className="form-check">
                                                                    <input
                                                                        type="checkbox"
                                                                        id="employee_rejection_notification2"
                                                                        name="employee_rejection_notification2"
                                                                        value="2"
                                                                        checked={this.state.employee_rejection_notification.includes('2')}
                                                                        onChange={(e) => this.handleCheckBoxChange('employee_rejection_notification', '2')}
                                                                        className="form-check-input"
                                                                    />
                                                                    <label htmlFor="employee_rejection_notification2" className="form-check-label">b) Web</label>
                                                                </div> */}
                                                                <div className="form-check">
                                                                    <input
                                                                        type="checkbox"
                                                                        id="employee_rejection_notification3"
                                                                        name="employee_rejection_notification3"
                                                                        value="2"
                                                                        checked={this.state.employee_rejection_notification.includes('3')}
                                                                        onChange={(e) => this.handleCheckBoxChange('employee_rejection_notification', '3')}
                                                                        className="form-check-input"
                                                                    />
                                                                    <label htmlFor="employee_rejection_notification3" className="form-check-label">b) Email</label>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <div className="form-check">
                                                                    <input
                                                                        type="checkbox"
                                                                        id="rejection_level_notification1"
                                                                        name="rejection_level_notification1"
                                                                        value="1"
                                                                        checked={this.state.rejection_level_notification.includes('1') || this.state.rejection_level_notification.includes('2')}
                                                                        onChange={() => this.handleRadioChange('rejection_level_notification', '1')}
                                                                        className="form-check-input"
                                                                    />
                                                                    <label htmlFor="rejection_level_notification1" className="form-check-label">Level1</label>
                                                                </div>
                                                                <div className="form-check">
                                                                    <input
                                                                        type="checkbox"
                                                                        id="rejection_level_notification2"
                                                                        name="rejection_level_notification2"
                                                                        value="2"
                                                                        checked={this.state.rejection_level_notification.includes('2')}
                                                                        onChange={(e) => this.handleRadioChange('rejection_level_notification', `${e.target.checked ? 2 : 1}`)}
                                                                        className="form-check-input"
                                                                    />
                                                                    <label htmlFor="rejection_level_notification2" className="form-check-label">Level2</label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {/* Submit Button */}
                                                    <div className="col-md-12" style={{ marginTop: "30px" }}>
                                                        {!this.state.postLoading ?
                                                            <SubmitBtn text={`${this.state.regularize_setting_id === 0 ? 'Save' : 'Update'}`} type="primary" icon="ri-save-line" /> :
                                                            <button disabled={true}
                                                                className={`btn btn-primary btn-label waves-effect right waves-light float-right`}>
                                                                <i className={`ri-save-line label-icon align-middle fs-16 ms-2`} />{" "}
                                                                Loading...
                                                            </button>
                                                        }

                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    };
}
export default withRouter(RegularizationSettings);